module.exports = __webpack_public_path__ + "media/images/countryrect/zm-e5f682efc1574fe1b4e45b0e3ab8ae6f.svg";